import { PrivateRoute } from 'components/utils/PrivateRoute'
import { Route } from 'react-router-dom'
import { URLS } from './constants'
import { PackagingInventoryUpdate } from './Shop/PackagingInventoryUpdate'
import { ListTrucks } from './Shop/GoodsReception/ListTrucks'
import { AddTruck } from './Shop/GoodsReception/ListTrucks/AddTruck'
import { ReceptionProcessing } from './Shop/GoodsReception/ReceptionProcessing'
import { Delivery } from './Shop/GoodsReception/Delivery'
import { InProgressReturnTrucks } from './Shop/GoodsReturn/InProgressReturnTrucks'
import { Step5 } from './Shop/GoodsReturn/Step5'
import { ExpectedTrucks } from './Hub/GoodsReception/ExpectedTrucks'
import { CreateTruckStep1 } from './Hub/GoodsReception/ExpectedTrucks/CreateTruckStep1'
import { CreateTruckStep2 } from './Hub/GoodsReception/ExpectedTrucks/CreateTruckStep2'
import { RegisterTruck } from './Hub/GoodsReception/RegisterTruck'
import { RegisterTruckStep2 } from './Hub/GoodsReception/RegisterTruck/RegisterTruckStep2'
import { RegisterTruckStep3 } from './Hub/GoodsReception/RegisterTruck/RegisterTruckStep3'
import { ExpenditureProcessing } from './Hub/GoodsReception/ExpenditureProcessing'
import { ShippedTrucks } from './Hub/GoodsReception/ShippedTrucks'
import { ExpectedReturns } from './Hub/GoodsReturn/ExpectedReturns'
import { InProgressReturn } from './Hub/GoodsReturn/InProgressReturn'
import { ContinueReturn } from './Hub/GoodsReturn/RecordReturn/ContinueReturn'
import { RecordReturn } from './Hub/GoodsReturn/RecordReturn'
import { SupportScanStep1 } from './Shop/GoodsReception/SupportScanStep1'
import { RecordReturnStep2 } from './Hub/GoodsReturn/RecordReturn/RecordReturnStep2'
import { TruckDetail } from './Shop/GoodsReception/ListTrucks/TruckDetail'
import { AddTruckStep2 } from './Shop/GoodsReception/ListTrucks/AddTruckStep2'
import { SupportScanStep2 } from './Shop/GoodsReception/SupportScanStep2'
import { Step4 } from './Shop/GoodsReturn/Step4'
import { Step3 } from './Shop/GoodsReturn/Step3'
import { Step2 } from './Shop/GoodsReturn/Step2'
import { SupportScanStep3 } from './Shop/GoodsReception/SupportScanStep3'
import { Step1 } from './Shop/GoodsReturn/Step1'
import { SupportScanStep5 } from './Shop/GoodsReception/SupportScanStep5'
import { SupportScanStep4 } from './Shop/GoodsReception/SupportScanStep4'
import { ExpectedReturnDetail } from './Hub/GoodsReturn/ExpectedReturns/ExpectedReturnDetail'
import { ExpectedReturnDetailStep2 } from './Hub/GoodsReturn/ExpectedReturns/ExpectedReturnDetailStep2'
import { ExpectedReturnDetailStep3 } from './Hub/GoodsReturn/ExpectedReturns/ExpectedReturnDetailStep3'
import { ExpectedReturnDetailFinal } from './Hub/GoodsReturn/ExpectedReturns/ExpectedReturnDetailFinal'
import { DeliveryDetail } from './Shop/GoodsReception/Delivery/DeliveryDetail'
import { RecordReturnStep3 } from './Hub/GoodsReturn/RecordReturn/RecordReturnStep3'
import { RecordReturnStep4 } from './Hub/GoodsReturn/RecordReturn/RecordReturnStep4'
import { RecordReturnStep5 } from './Hub/GoodsReturn/RecordReturn/RecordReturnStep5'
import { DeliveryCompleteScan } from './Shop/GoodsReception/Delivery/DeliveryDetail/DeliveryCompleteScan'
import { DeliverySensitiveProducts } from './Shop/GoodsReception/Delivery/DeliveryDetail/DeliverySensitiveProducts'
import { DeliveryRandomSupport } from './Shop/GoodsReception/Delivery/DeliveryDetail/DeliveryRandomSupport'
import { DeliveryCompleteScanStep1 } from './Shop/GoodsReception/Delivery/DeliveryDetail/DeliveryCompleteScan/DeliveryCompleteScanStep1'
import { DeliveryCompleteScanStep2 } from './Shop/GoodsReception/Delivery/DeliveryDetail/DeliveryCompleteScan/DeliveryCompleteScanStep2'
import { DeliverySensitiveProductsConfirm } from './Shop/GoodsReception/Delivery/DeliveryDetail/DeliverySensitiveProducts/DeliverySensitiveProductsConfirm'
import { DeliveryRandomProduct } from './Shop/GoodsReception/Delivery/DeliveryDetail/DeliveryRandomProduct'
import { DeliveryRandomSupportFinal } from './Shop/GoodsReception/Delivery/DeliveryDetail/DeliveryRandomSupport/DeliveryRandomSupportFinal'
import { DeliveryRandomSupportConfirm } from './Shop/GoodsReception/Delivery/DeliveryDetail/DeliveryRandomSupport/DeliveryRandomSupportConfirm'
import { DeliveryRandomProductFinal } from './Shop/GoodsReception/Delivery/DeliveryDetail/DeliveryRandomProduct/DeliveryRandomProductFinal'
import ExpectedDepositReturns from './Deposit/ExpectedReturns/ExpectedDepositReturns'
import { ExpectedDepositReturnsStep1 } from './Deposit/ExpectedReturns/Step1'
import { ExpectedDepositReturnsStep2 } from './Deposit/ExpectedReturns/Step2'
import { ExpectedDepositReturnsStep3 } from './Deposit/ExpectedReturns/Step3'
import { ExpectedDepositReturnsStep4 } from './Deposit/ExpectedReturns/Step4'
import { ReturnPendingReception } from './Deposit/ReturnPendingReception'
import { ExpectedTrucksStep2 } from './Hub/GoodsReception/ExpectedTrucks/ExpectedTrucksStep2'
import { ExpectedTrucksStep3 } from './Hub/GoodsReception/ExpectedTrucks/ExpectedTrucksStep3'
import { ExpectedTrucksStep4 } from './Hub/GoodsReception/ExpectedTrucks/ExpectedTrucksStep4'
import { ExpectedTrucksStep5 } from './Hub/GoodsReception/ExpectedTrucks/ExpectedTrucksStep5'
import { ExpectedTrucksStep6 } from './Hub/GoodsReception/ExpectedTrucks/ExpectedTrucksStep6'
import DeliveryRandomProductModifica from './Shop/GoodsReception/Delivery/DeliveryDetail/DeliveryRandomProduct/DeliveryRandomProductConfirm/DeliveryRandomProductModifica'
import { DeliveryShortDLC } from './Shop/GoodsReception/Delivery/DeliveryDetail/DeliveryShortDLC'
import { InProcessReceptionTrucks } from './Hub/GoodsReception/InProcessReceptionTrucks'
import { RecordReturnStep6 } from './Hub/GoodsReturn/RecordReturn/RecordReturnStep6'
import { TruckSearchDeliveryTicket } from './Shop/GoodsReception/ListTrucks/TruckSearchDeliveryTicket'
import { SealScan } from './Shop/Returo/SealScan'
import { InProgressSeals } from './Shop/Returo/InProgressSeals'
import { AddReport } from './Shop/Returo/AddReport'
import { ReportProcessing } from './Shop/Returo/ReportProcessing'
import { AddReportSelectSeals } from './Shop/Returo/AddReportSelectSeals'
import { AddReportPrint } from './Shop/Returo/AddReportPrint'
import { SupplierList } from './Shop/DirectSuppliers/SupplierReception'
import { OrderList } from './Shop/DirectSuppliers/SupplierReception/OrderList'
import { OrderDetails } from './Shop/DirectSuppliers/SupplierReception/OrderDetails'
import { GoodsValidation } from './Shop/DirectSuppliers/SupplierReception/GoodsValidation'
import { RayonList } from './Shop/DirectSuppliers/SupplierReception/RayonList'
import { InProgressReception } from "./Shop/DirectSuppliers/SupplierReception/InProgressReception"
import { InventoryUpdate } from "./Shop/DirectSuppliers/InventoryUpdate"
import { InProgressReturns } from "./Shop/DirectSuppliers/PackageReturn/InProgressReturn"
import { ReturnStep1 } from "./Shop/DirectSuppliers/PackageReturn/ReturnStep1"
import { ReturnStep2 } from "./Shop/DirectSuppliers/PackageReturn/ReturnStep2"
import { ReturnStep3 } from "./Shop/DirectSuppliers/PackageReturn/ReturnStep3"
import { ReturnStep4 } from "./Shop/DirectSuppliers/PackageReturn/ReturnStep4"
import { ReturnStep5 } from "./Shop/DirectSuppliers/PackageReturn/ReturnStep5"
import { ProductConfirmation } from "./Shop/DirectSuppliers/SupplierReception/ProductConfirmation"
import { PackageSelection } from "./Shop/DirectSuppliers/SupplierReception/PackageSelection"
import { PackageConfirmation } from "./Shop/DirectSuppliers/SupplierReception/PackageConfirmation"
import { NoticeUpload } from "./Shop/DirectSuppliers/SupplierReception/NoticeUpload"
import { RegisterTruckStep4 } from "./Hub/GoodsReception/RegisterTruck/RegisterTruckStep4"
import { ReceiptReport } from "./Shop/DirectSuppliers/SupplierReception/ReceiptReport"
import React from "react"

export const useMerchandiseRoutes = applicationPages => {
  return (
    <>
      {/* Goods reception */}
      <Route
        path={URLS.AUTH_RECEPTION_PROCESSING}
        element={
          <PrivateRoute
            component={ReceptionProcessing}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />
      <Route
        path={URLS.AUTH_EXPECTED_TRUCKS}
        element={
          <PrivateRoute
            component={ExpectedTrucks}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />
      <Route
        path={URLS.AUTH_EXPECTED_TRUCKS_STEP2}
        element={
          <PrivateRoute
            component={ExpectedTrucksStep2}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />
      <Route
        path={URLS.AUTH_EXPECTED_TRUCKS_STEP3}
        element={
          <PrivateRoute
            component={ExpectedTrucksStep3}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />
      <Route
        path={URLS.AUTH_EXPECTED_TRUCKS_STEP4}
        element={
          <PrivateRoute
            component={ExpectedTrucksStep4}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />
      <Route
        path={URLS.AUTH_EXPECTED_TRUCKS_STEP5}
        element={
          <PrivateRoute
            component={ExpectedTrucksStep5}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />
      <Route
        path={URLS.AUTH_EXPECTED_TRUCKS_STEP6}
        element={
          <PrivateRoute
            component={ExpectedTrucksStep6}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />
      <Route
        path={URLS.AUTH_IN_PROCESS_TRUCKS}
        element={
          <PrivateRoute
            component={InProcessReceptionTrucks}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />
      <Route
        path={URLS.AUTH_CREATE_TRUCK}
        element={
          <PrivateRoute
            component={CreateTruckStep1}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />
      <Route
        path={URLS.AUTH_CREATE_TRUCK_STEP_2}
        element={
          <PrivateRoute
            component={CreateTruckStep2}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />
      <Route
        path={URLS.AUTH_REGISTER_TRUCK}
        element={
          <PrivateRoute
            component={RegisterTruck}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />
      <Route
        path={URLS.AUTH_REGISTER_TRUCK_STEP_2}
        element={
          <PrivateRoute
            component={RegisterTruckStep2}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />
      <Route
        path={URLS.AUTH_REGISTER_TRUCK_STEP_3}
        element={
          <PrivateRoute
            component={RegisterTruckStep3}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />
      <Route
        path={URLS.AUTH_REGISTER_TRUCK_STEP_4}
        element={
          <PrivateRoute
            component={RegisterTruckStep4}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />
      <Route
        path={URLS.AUTH_PROCESSING_SHIPMENT}
        element={
          <PrivateRoute
            component={ExpenditureProcessing}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />
      <Route
        path={URLS.AUTH_SHIPPED_TRUCKS}
        element={
          <PrivateRoute
            component={ShippedTrucks}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />
      <Route
        path={URLS.AUTH_SUPPORT_SCAN_STEP_1}
        element={
          <PrivateRoute
            component={SupportScanStep1}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />
      <Route
        path={URLS.AUTH_ADD_TRUCK}
        element={
          <PrivateRoute
            component={AddTruck}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />
      <Route
        path={URLS.AUTH_LIST_TRUCKS}
        element={
          <PrivateRoute
            component={ListTrucks}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />
      <Route
        path={URLS.AUTH_TRUCK_SEARCH_DELIVERY_TICKET}
        element={
          <PrivateRoute
            component={TruckSearchDeliveryTicket}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />
      <Route
        path={URLS.AUTH_DELIVERY}
        element={
          <PrivateRoute
            component={Delivery}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />
      <Route
        path={URLS.AUTH_DELIVERY_DETAIL}
        element={
          <PrivateRoute
            component={DeliveryDetail}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />
      <Route
        path={URLS.AUTH_DELIVERY_COMPLETE_SCAN}
        element={
          <PrivateRoute
            component={DeliveryCompleteScan}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />
      <Route
        path={URLS.AUTH_DELIVERY_SENSITIVE_PRODUCTS}
        element={
          <PrivateRoute
            component={DeliverySensitiveProducts}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />
      <Route
        path={URLS.AUTH_DELIVERY_RANDOM_SUPPORT}
        element={
          <PrivateRoute
            component={DeliveryRandomSupport}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />
      <Route
        path={URLS.AUTH_DELIVERY_RANDOM_PRODUCT}
        element={
          <PrivateRoute
            component={DeliveryRandomProduct}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />

      {/* Goods return */}
      <Route
        path={URLS.AUTH_EXPECTED_RETURNS}
        element={
          <PrivateRoute
            component={ExpectedReturns}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />
      <Route
        path={URLS.AUTH_IN_PROGRESS_RETURN}
        element={
          <PrivateRoute
            component={InProgressReturn}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />
      <Route
        path={URLS.AUTH_RECORD_RETURN}
        element={
          <PrivateRoute
            component={RecordReturn}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />
      <Route
        path={URLS.AUTH_CONTINUE_RETURN}
        element={
          <PrivateRoute
            component={ContinueReturn}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />
      <Route
        path={URLS.AUTH_EXPECTED_RETURN_DETAIL}
        element={
          <PrivateRoute
            component={ExpectedReturnDetail}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />
      <Route
        path={URLS.AUTH_TRUCK_DETAIL}
        element={
          <PrivateRoute
            component={TruckDetail}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />
      <Route
        path={URLS.AUTH_RECORD_RETURN_STEP_2}
        element={
          <PrivateRoute
            component={RecordReturnStep2}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />
      <Route
        path={URLS.AUTH_RECORD_RETURN_STEP_3}
        element={
          <PrivateRoute
            component={RecordReturnStep3}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />
      <Route
        path={URLS.AUTH_RECORD_RETURN_STEP_6}
        element={
          <PrivateRoute
            component={RecordReturnStep6}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />
      <Route
        path={URLS.AUTH_RETURN_STEP_5}
        element={
          <PrivateRoute component={Step5} applicationPages={applicationPages} checkIsAuthorized />
        }
      />
      <Route
        path={URLS.AUTH_CONTINUE_RETURN_TRUCKS}
        element={
          <PrivateRoute
            component={InProgressReturnTrucks}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />

      {/* Deposit return */}
      <Route
        path={URLS.AUTH_DEPOSIT_EXPECTED_RETURNS}
        element={
          <PrivateRoute
            component={ExpectedDepositReturns}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />
      <Route
        path={URLS.AUTH_DEPOSIT_EXPECTED_RETURNS_STEP_1}
        element={
          <PrivateRoute
            component={ExpectedDepositReturnsStep1}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />
      <Route
        path={URLS.AUTH_DEPOSIT_EXPECTED_RETURNS_STEP_2}
        element={
          <PrivateRoute
            component={ExpectedDepositReturnsStep2}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />
      <Route
        path={URLS.AUTH_DEPOSIT_EXPECTED_RETURNS_STEP_3}
        element={
          <PrivateRoute
            component={ExpectedDepositReturnsStep3}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />
      <Route
        path={URLS.AUTH_DEPOSIT_EXPECTED_RETURNS_STEP_4}
        element={
          <PrivateRoute
            component={ExpectedDepositReturnsStep4}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />
      <Route
        path={URLS.AUTH_DEPOSIT_PENDING_RETURN}
        element={
          <PrivateRoute
            component={ReturnPendingReception}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />
      <Route
        path={URLS.AUTH_DELIVERY_SHORT_DLC_PRODUCTS}
        element={
          <PrivateRoute
            component={DeliveryShortDLC}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />

      {/* Returo */}
      <Route
        path={URLS.AUTH_RETURO_SCAN_SEALS}
        element={
          <PrivateRoute
            component={SealScan}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />
      <Route
        path={URLS.AUTH_RETURO_IN_PROGRESS_SEALS}
        element={
          <PrivateRoute
            component={InProgressSeals}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />
      <Route
        path={URLS.AUTH_RETURO_ADD_REPORT}
        element={
          <PrivateRoute
            component={AddReport}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />
      <Route
        path={URLS.AUTH_RETURO_ADD_REPORT_SELECT_SEALS}
        element={
          <PrivateRoute
            component={AddReportSelectSeals}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />
      <Route
        path={URLS.AUTH_RETURO_ADD_REPORT_PRINT}
        element={
          <PrivateRoute
            component={AddReportPrint}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />
      <Route
        path={URLS.AUTH_RETURO_PROCESSING_REPORT}
        element={
          <PrivateRoute
            component={ReportProcessing}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />

      {/* Furnizori Directi */}
      <Route
        path={URLS.AUTH_SUPPLIERS_LIST}
        element={
          <PrivateRoute
            component={SupplierList}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />
      <Route
        path={URLS.AUTH_SUPPLIERS_RECEPTION}
        element={
          <PrivateRoute
            component={InProgressReception}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />
      <Route
        path={URLS.AUTH_SUPPLIERS_RAYON_LIST}
        element={
          <PrivateRoute
            component={RayonList}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />
      <Route
        path={URLS.AUTH_SUPPLIERS_ORDER_LIST}
        element={
          <PrivateRoute
            component={OrderList}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />
      <Route
        path={URLS.AUTH_SUPPLIERS_ORDER_DETAILS}
        element={
          <PrivateRoute
            component={OrderDetails}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />
      <Route
        path={URLS.AUTH_SUPPLIERS_GOODS_VALIDATION}
        element={
          <PrivateRoute
            component={GoodsValidation}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />
      <Route
        path={URLS.AUTH_SUPPLIERS_DELIVERY_VALIDATION}
        element={
          <PrivateRoute
            component={ProductConfirmation}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />
      <Route
        path={URLS.AUTH_SUPPLIERS_PACKAGE_INPUT}
        element={
          <PrivateRoute
            component={PackageSelection}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />
      <Route
        path={URLS.AUTH_SUPPLIERS_PACKAGE_CONFIRMATION}
        element={
          <PrivateRoute
            component={PackageConfirmation}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />
      <Route
        path={URLS.AUTH_SUPPLIERS_RECEIPT_REPORT}
        element={
          <PrivateRoute
            component={ReceiptReport}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />
      <Route
        path={URLS.AUTH_SUPPLIERS_NOTICE_INPUT}
        element={
          <PrivateRoute
            component={NoticeUpload}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />
      <Route
        path={URLS.AUTH_SUPPLIERS_INVENTORY_UPDATE}
        element={
          <PrivateRoute
            component={InventoryUpdate}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />
      <Route
        path={URLS.AUTH_SUPPLIERS_CONTINUE_RETURN}
        element={
          <PrivateRoute
            component={InProgressReturns}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />
      <Route
        path={URLS.AUTH_SUPPLIERS_RECORD_RETURN}
        element={
          <PrivateRoute
            component={ReturnStep1}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />
      <Route
        path={URLS.AUTH_SUPPLIERS_RETURN_STEP_2}
        element={
          <PrivateRoute
            component={ReturnStep2}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />
      <Route
        path={URLS.AUTH_SUPPLIERS_RETURN_STEP_3}
        element={
          <PrivateRoute
            component={ReturnStep3}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />
      <Route
        path={URLS.AUTH_SUPPLIERS_RETURN_STEP_4}
        element={
          <PrivateRoute
            component={ReturnStep4}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />
      <Route
        path={URLS.AUTH_SUPPLIERS_RETURN_STEP_5}
        element={
          <PrivateRoute
            component={ReturnStep5}
            applicationPages={applicationPages}
            checkIsAuthorized
          />
        }
      />

      {/* ? */}
      <Route path={URLS.AUTH_PACKAGING_INVENTORY_UPDATE} element={<PackagingInventoryUpdate />} />
      <Route path={URLS.AUTH_SUPPORT_SCAN_STEP_2} element={<SupportScanStep2 />} />
      <Route path={URLS.AUTH_SUPPORT_SCAN_STEP_3} element={<SupportScanStep3 />} />
      <Route path={URLS.AUTH_SUPPORT_SCAN_STEP_4} element={<SupportScanStep4 />} />
      <Route path={URLS.AUTH_SUPPORT_SCAN_STEP_5} element={<SupportScanStep5 />} />

      <Route path={URLS.AUTH_RETURN_STEP_4} element={<Step4 />} />
      <Route path={URLS.AUTH_RETURN_STEP_3} element={<Step3 />} />
      <Route path={URLS.AUTH_RETURN_STEP_2} element={<Step2 />} />
      <Route path={URLS.AUTH_RETURN_STEP_1} element={<Step1 />} />

      {/* TODO: Delete after integration of steppers in parent pages */}
      <Route path={URLS.AUTH_ADD_TRUCK_STEP_2} element={<AddTruckStep2 />} />
      <Route
        path={URLS.AUTH_EXPECTED_RETURN_DETAIL_STEP_2}
        element={<ExpectedReturnDetailStep2 />}
      />
      <Route
        path={URLS.AUTH_EXPECTED_RETURN_DETAIL_STEP_3}
        element={<ExpectedReturnDetailStep3 />}
      />
      <Route
        path={URLS.AUTH_EXPECTED_RETURN_DETAIL_FINAL}
        element={<ExpectedReturnDetailFinal />}
      />
      <Route path={URLS.AUTH_RECORD_RETURN_STEP_4} element={<RecordReturnStep4 />} />
      <Route path={URLS.AUTH_RECORD_RETURN_STEP_5} element={<RecordReturnStep5 />} />
      <Route
        path={URLS.AUTH_DELIVERY_COMPLETE_SCAN_STEP_1}
        element={<DeliveryCompleteScanStep1 />}
      />
      <Route
        path={URLS.AUTH_DELIVERY_COMPLETE_SCAN_STEP_2}
        element={<DeliveryCompleteScanStep2 />}
      />
      <Route
        path={URLS.AUTH_DELIVERY_SENSITIVE_PRODUCTS_CONFIRM}
        element={<DeliverySensitiveProductsConfirm />}
      />

      <Route
        path={URLS.AUTH_DELIVERY_RANDOM_SUPPORT_FINAL}
        element={<DeliveryRandomSupportFinal />}
      />
      <Route
        path={URLS.AUTH_DELIVERY_RANDOM_SUPPORT_CONFIRM}
        element={<DeliveryRandomSupportConfirm />}
      />
      <Route
        path={URLS.AUTH_DELIVERY_RANDOM_PRODUCT_FINAL}
        element={<DeliveryRandomProductFinal />}
      />
      <Route
        path={URLS.AUTH_DELIVERY_RANDOM_PRODUCT_CONFIRM}
        element={<DeliveryRandomProductModifica />}
      />
    </>
  )
}
